<template>
    <div class="used_car_item">
        <UsedCarListItem :item="data" />
        <ItemTabs ref="itemTabs" />
        <van-goods-action>
            <a :href="'tel:' + data.used_car_shop.shop_tel">
                <van-goods-action-icon icon="phone-o" text="联系"/>
            </a>
            <van-goods-action-icon icon="chat-o" text="分享" @click="onShare" />
            <van-goods-action-icon icon="comment-o" text="留言" @click="onMsg" />
            <van-goods-action-icon :icon="data.has_favorites? 'star' : 'star-o'" text="收藏" @click="onFavorite" />
            <van-goods-action-button v-if="data.state !=null && data.state.state==1" type="primary" style="background-color: #2196F3;color:white;" text="立即预定" @click="onOrder" />
            <van-goods-action-button v-else type="primary" disabled style="background-color: #2196F3;color:white;" text="立即预定" @click="onOrder" />
        </van-goods-action>
        <ToShare ref="toshare" />
        <SendMessage ref="sendMsg" @sendMsg="sendMessage" />
    </div>
</template>

<script>
import { 
    NavBar,
    Grid,
    GridItem,
    Image,
    Row,
    Col,
    Icon, 
    Loading, 
    List,
    Toast,
    GoodsAction,
    GoodsActionIcon,
    GoodsActionButton
} from 'vant'

import { UsedCarShopApi, UsedCarFavoritesApi } from '@/api/usedcar'
import { MsgApi } from '@/api/message'
import UsedCarListItem from '@/view/usedcar/components/usedcarlistitem'
import SendMessage from '@/view/components/sendmessage'
import ItemTabs from '@/view/usedcar/components/itemtabs'
import ToShare from '@/view/components/toshare'
import wxshare from '@/utils/wxshare'
import { getOpenId } from '@/utils/auth'
import { toThousands } from '@/utils/formatutils'

export default {
    name: 'UsedCarItem',
    components: {
        [NavBar.name]: NavBar,
        [Icon.name]: Icon,
        [Loading.name]: Loading,
        [List.name]: List,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Image.name]: Image,
        [Row.name]: Row,
        [Col.name]: Col,
        [Toast.name]: Toast,
        [GoodsAction.name]: GoodsAction,
        [GoodsActionIcon.name]: GoodsActionIcon,
        [GoodsActionButton.name]: GoodsActionButton,
        UsedCarListItem,
        SendMessage,
        ItemTabs,
        ToShare
    },
    data() {
        return {
            id: null,
            data: {
                used_car_shop: {
                    servers: [],
                    versions: []
                }
            },
            loading: false,
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getData()
    },
    methods: {
        getData() {
            var that = this
            this.axios.get(UsedCarShopApi + that.id + '/').then((ret) => {
                console.log(ret)
                that.data = ret
                that.$refs.itemTabs.refresh(that.data)

                const openid = getOpenId()
                console.log(openid)
                console.log('分享信息')
                console.log(ret)
                const totalAmount = toThousands((Number(that.data.channel_amount) + Number(that.data.deposit) + Number(that.data.used_car_shop.server_amount))/10000)
                let rem = '售价:' + totalAmount + "万元"
                wxshare.shareItem(`您的好友正在分享${that.data.title}`, 
                    rem, 
                    that.data.img_url, 
                    `${window.location.origin}/#/nt/usedcar/${this.data.id}/?shared_id=` + openid )
            })
        },
        getShopInfo(obj) {
            console.log('getShopInfo')
            console.log(obj)
        },
        onMsg() {
            this.$refs.sendMsg.show('请输入发送信息...')
        },
        sendMessage(data) {
            if (data.msg=='' || data.msg==null){
                Toast.show('必须录入发送信息')
            } else {
                var that = this
                let postData = {
                    source_style: 2,
                    source_id: this.id,
                    message: data.msg,
                }
                that.axios.post(MsgApi, postData).then((ret) => {
                    console.log(ret)
                    if (ret.flag) {
                        that.$refs.sendMsg.hide()
                        Toast('留言已经发送...')
                    } else {
                        Toast(ret.info)
                    }
                })
            }
        },
        onShare() {
            this.$refs.toshare.show()
        },
        onFavorite() {
            var that = this
            const postData = {
                usedcar: that.id
            }
            this.axios.post(UsedCarFavoritesApi, postData).then((ret) => {
                console.log(ret)
                if (ret.flag) {
                    that.data.has_favorites = ! that.data.has_favorites
                } else {
                    Toast(ret.info)
                }
            })
        },
        onOrder() {
            this.$router.push(`/nt/usedcarbuy/${this.data.id}/?shared_id=${this.$route.query.shared_id}`)
        }
    }
}
</script>

<style lang="less">
.used_car_item {
     .van-goods-action-icon__icon {
         color: #2196F3;
     }
     .van-goods-action-button--primary {
         color: #2196F3;
         background-color: #2196F3;
     }
}

</style>
